<template>
    <order-offer-map/>
</template>

<script>
import OrderOfferMap from './Components/OrderOfferMap'
export default {
    components: {OrderOfferMap},
}
</script>

<style>

</style>